export default {
  name: 'star',
  title: 'Polygone/Star Tool',
  buttons: [
    {
      title: 'Star Tool'
    },
    {
      title: 'Polygon Tool'
    }
  ],
  contextTools: [
    {
      title: 'Number of Sides',
      label: 'points'
    },
    {
      title: 'Pointiness',
      label: 'Pointiness'
    },
    {
      title: 'Twists the star',
      label: 'Radial Shift'
    },
    {
      title: 'Number of Sides',
      label: 'sides'
    }
  ]
};
